import { useTranslation } from 'next-i18next';
import React from 'react';

import { useGetApprovalPathDetails } from '@/modules/settings/approvals/apiHooks';
import { useTechnicalApprovals } from '@/modules/settings/approvals/components/Operations/logic';
import ApprovalDetails from '@/modules/settings/approvals/components/shared/ApprovalDetails';
import { Loading } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
interface IProps {
  id: number;
  entityId: number;
}

const OperationsApprovalDetails = ({ id, entityId }: IProps) => {
  const { t } = useTranslation('common');
  const { data, isLoading } = useGetApprovalPathDetails({ id, entityId });
  const { getCardDetils } = useTechnicalApprovals();
  if (isLoading) {
    return <Loading />;
  }
  if (!data) {
    return (
      <EmptyCard
        classeName='bg-white  p-40'
        variant='text'
        message={t('no-data')}
      />
    );
  }
  return (
    <ApprovalDetails
      entityId={entityId}
      approvalPathId={id}
      approvers={data.approvers}
      cards={getCardDetils(data)}
    />
  );
};
export default OperationsApprovalDetails;
